import React, {useState, useEffect} from "react";
import '../App.css';
import { trackPromise } from 'react-promise-tracker';
import LazyImage from "./LazyLoad/LazyLoad";
const Places = ()=>{
    const [datax, setDatax] = useState([]);
    const apiUrl = 'https://cors-anywhere.herokuapp.com/http://open-api.myhelsinki.fi/v1/places/';
    useEffect(()=>{
        trackPromise(fetch(apiUrl)
                .then((response)=>response.json())
                .then((data) => setDatax(data.data))
        )}, []
    )
    const events = datax.map((name)=>{

            const selectedLanguage = name.name.fi;
            const images = name.description.images;
            const description = name.description.body.replace( /(<([^>]+)>)/ig, '').replace(/&nbsp;/ig,'').replace(/&nbsp;/ig,'');
            const pics = () => {
                let piclist=[];
                images.forEach(
                    (image)=> {
                        piclist.push(<LazyImage src={image.url}  width={image.width} alt=""   />);
                    });
                return piclist;
            }
            return (
                <div className="container">
                <a href={name.info_url} target="new">
                    <div className="column-2 box">
                        <div className="imageSize">{pics()}</div>
                    </div>
                    <div className="column-1 box">
                        <h1>{selectedLanguage}</h1>
                        {description}
                    </div>
                </a></div>);
        }
    );
    return  <div>{events}</div>

}
export default Places;
